import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GeneralesService {

  url = GlobalVariable.BASE_API_URL;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  constructor(private http: HttpClient) { }

  // Simulación
  getPanel() {
    return this.http.post(`${this.url}Generales/getPanel`, null, { headers: this.headersc });
  }
  
  getEmailByRut(rut: string) {
    return this.http.post(`${this.url}Generales/GetMail?rut=${rut}`, null, { headers: this.headersc });
  }
}
